module.exports = __webpack_public_path__ + "static/media/career-planning-thumbnail.c5c7bf2b.png";